<template>
  <div>
    <b-card title="Görsel">
      <b-img
        v-if="dataItem.image"
        :src="dataItem.image"
        thumbnail
        center
      />
      <div class="text-center mt-1">
        <b-button
          variant="primary"
          @click="setModal('welcome')"
        >
          <FeatherIcon icon="UploadIcon" />
          Görsel Yükle
        </b-button>
      </div>
    </b-card>
    <cropper-image
      v-if="cropperSettings.type"
      :modal-status="cropperSettings.modalStatus"
      :close-modal="closeModal"
      :file-name="cropperSettings.fileName"
      :folder="cropperSettings.folder"
      :ratio="cropperSettings.ratio"
      :width-size="cropperSettings.widthSize"
      component="welcome"
      :params="cropperSettings.type"
      :item-id="dataItem.id"
      @uploadImage="setUploadImage"
    />
  </div>
</template>

<script>
import {
  BButton, BCard, BImg,
} from 'bootstrap-vue'
import CropperImage from '@/layouts/components/common/CropperImage.vue'

export default {
  name: 'ImageCard',
  components: {
    CropperImage,
    BButton,
    BImg,
    BCard,
  },
  data() {
    return {
      baseURL: this.$store.state.app.baseURL,
      userData: JSON.parse(localStorage.getItem('userData')),
      cropperSettings: {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        widthSize: null,
        type: null,
      },
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['welcome/dataItem']
    },
  },
  methods: {
    setModal(type) {
      if (type === 'welcome') {
        this.cropperSettings = {
          modalStatus: true,
          fileName: 'welcome-desktop-image.jpg',
          folder: 'welcome',
          ratio: 9 / 16,
          widthSize: 1080,
          type: 'welcome',
        }
      }
    },
    closeModal() {
      this.cropperSettings = {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        type: null,
      }
    },
    setUploadImage(item) {
      if (this.cropperSettings.type === 'welcome') {
        this.dataItem.image = item.base_url + item.filename
        this.dataItem.thumb = item.base_url + item.thumb
        this.dataItem.image_webp = item.base_url + item.image_webp
        this.dataItem.thumb_webp = item.base_url + item.thumb_webp
        this.dataItem.mediaData = item
      }
      this.cropperSettings.modalStatus = false
    },
  },
}
</script>
